<div class="travel-class-button border rounded-medium shadow-small white-bg flex flex--column flex--left-center">
  <button
    class="ps-medium-l ps-xsmall-r focus-inset align-left flex flex--space-between flex--center"
    (click)="openModal()"
    data-testid="destinations-travel-class-button"
  >
    <div class="flex flex--column flex--left-center">
      <span class="font-body-1 regular-type nordic-blue-900-text">
        {{ 'travelClasses' | finLocalization }}
      </span>
      <span class="medium-type font-body-1 nordic-blue-900-text" data-testid="destinations-travel-class-value">
        {{ COMMON_BOOKING_TRAVEL_CLASSES[selectedTravelClass].translationKey | finLocalization }}
      </span>
    </div>
    <fcom-icon class="icon-medium" [name]="SvgLibraryIcon.CHEVRON_DOWN"></fcom-icon>
  </button>
</div>

<fcom-modal [(open)]="modalOpen" [title]="'travelClasses' | finLocalization" [buttons]="null" [fitToContent]="true">
  <div
    role="radiogroup"
    aria-label="'destinationSearch.travelClasses.travelClass' | finLocalization"
    class="pr-large-x flex-1 white-bg fill ps-xsmall-b"
    *ngIf="travelClasses as travelClasses"
    data-testid="destinatinos-travel-class-modal"
  >
    <div
      *ngFor="let travelClass of travelClasses; index as i"
      class="traveClass-option flex--space-between flex flex--middle link-hover"
      [class.border-bottom]="travelClasses.length - 1 !== i"
    >
      <input
        class="is-vishidden"
        [attr.id]="'travelClass-' + travelClass"
        type="radio"
        name="travelclass"
        [attr.value]="travelClass"
        (keyup.enter)="selectTravelClass(travelClass)"
      />
      <label
        [attr.for]="'travelClass-' + travelClass"
        class="font-body-1 ps-medium-y fill"
        [class.link-hover]="selectedTravelClass !== travelClass"
        [class.nordic-blue-900-text]="selectedTravelClass === travelClass"
        (click)="selectTravelClass(travelClass)"
      >
        {{ COMMON_BOOKING_TRAVEL_CLASSES[travelClass].translationKey | finLocalization }}
      </label>
      <fcom-icon
        *ngIf="selectedTravelClass === travelClass"
        class="icon-medium heather-700-text"
        [name]="SvgLibraryIcon.CHECKMARK"
      ></fcom-icon>
    </div>
  </div>
</fcom-modal>
